import { Box } from "@mui/material";
import { isNil } from "lodash";
import { useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import OwlDmt from "../../core/assets/oot/classic/Owl_Dmt.png";
import OwlLake from "../../core/assets/oot/classic/Owl_Lake.png";
import Bolero from "../../core/assets/oot/song/bolero.png";
import Minuet from "../../core/assets/oot/song/minuet.png";
import Nocturne from "../../core/assets/oot/song/nocturne.png";
import Prelude from "../../core/assets/oot/song/prelude.png";
import Requiem from "../../core/assets/oot/song/requiem.png";
import Serenade from "../../core/assets/oot/song/serenade.png";
import { LocationQueryAutocomplete } from "../hints/LocationAutocomplete";
import { LocationDto } from "../locations/LocationDtos";
export interface WarpDto {
    name: string,
    img?: string,
    destination?: LocationDto
}

export interface WarpSongDto {
    song: string,
    img: string,
    destination?: LocationDto

}


export const WarpSongs: Array<WarpDto> = [
    { name: "Minuet of Forest", img: Minuet },
    { name: "Bolero of Fire", img: Bolero },
    { name: "Serenade of Water", img: Serenade },
    { name: "Nocturne of Shadow", img: Nocturne },
    { name: "Requiem of Spirit", img: Requiem },
    { name: "Prelude of Light", img: Prelude },
]


export const OwlWarp: Array<WarpDto> = [
    { name: "Owl DMT", img: OwlDmt },
    { name: "Owl Lake", img: OwlLake },
]

const WarpTracker = () => {

    let isWarpSongRandom = useSelector((state: AppState) => state.ui.ootr.main.isWarpSongRandom)
    let isOwlRandom = useSelector((state: AppState) => state.ui.ootr.main.isOwlRandom)
    let isSpawnChildRandom = useSelector((state: AppState) => state.ui.ootr.main.isSpawnChildRandom)
    let isSpawnAdultRandom = useSelector((state: AppState) => state.ui.ootr.main.isSpawnAdultRandom)

    let [adultSpawn, setAdultSpawn] = useState<LocationDto | null>(null);
    let [childSpawn, setChildSpawn] = useState<LocationDto | null>(null);

    return <Box display="flex" flexBasis={"fit-content"} flexDirection={"row"} justifyContent={"space-between"} maxWidth={"500px"} marginX={"10px"}>
        {isWarpSongRandom && <Box display={"flex"} flexDirection={"column"}>
            {WarpSongs.map(w => {
                return <WarpTrackSelection warp={w} />
            })
            }
        </Box>
        }

        {isOwlRandom && <Box display={"flex"} flexDirection={"column"} flexBasis={"fit-content"}>
            {OwlWarp.map(w => {
                return <WarpTrackSelection warp={w} />
            })
            }
        </Box>
        }

        {(isSpawnAdultRandom || isSpawnChildRandom) && <Box display={"flex"} flexDirection={"column"} flexBasis={"fit-content"}>
            {isSpawnAdultRandom && <Box display="flex" flexBasis={"fit-content"} >
                {isNil(adultSpawn) && <LocationQueryAutocomplete selection={adultSpawn} additionalOnChange={(l) => setAdultSpawn(l)} locationTypeId={1} sx={{ width: "120px" }} label="Adult Spawn" />}
                {!isNil(adultSpawn) && <Box textAlign="center" onClick={() => setAdultSpawn(null)}>Adult : {adultSpawn.name}</Box>}
            </Box>}
            {isSpawnChildRandom && <Box display="flex" flexBasis={"fit-content"} alignItems={"center"}>
                {isNil(childSpawn) && <LocationQueryAutocomplete selection={childSpawn} additionalOnChange={(l) => setChildSpawn(l)} locationTypeId={1} sx={{ width: "120px" }} label="Child Spawn" />}
                {!isNil(childSpawn) && <Box textAlign="center" onClick={() => setChildSpawn(null)}>Child : {childSpawn.name}</Box>}
            </Box>}
        </Box>
        }

    </Box>
}

export default WarpTracker;


interface WarpTrackSelectionProps {
    warp: WarpDto
}

export const WarpTrackSelection = (props: WarpTrackSelectionProps) => {

    let [warp, setWarp] = useState<LocationDto | null>(null);

    return <Box display={"flex"} flexDirection={"row"} textAlign={"center"}>
        <img src={props.warp.img} alt={props.warp.name} width={30} height={30} />
        {isNil(warp) && <LocationQueryAutocomplete selection={warp} additionalOnChange={(w) => setWarp(w)} sx={{ width: "100px" }} label="Location" locationTypeId={1} />}
        {!isNil(warp) && <Box textAlign={"center"} onClick={() => setWarp(null)}>{warp.name}</Box>}
    </Box>
}